import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'utils/components/modal';
import RadioButtonsInput from '../radio-buttons-input';
import ModalInpageSkin from '../../../modals/inpage-skin';

var InpageSkinKeys = {
  LIGHT: { value: 'light', text: 'For light background' },
  DARK: { value: 'dark', text: 'For dark background' }
};

function getInpageSkin(value) {
  var inpageSkin = null;
  switch (value) {
    case 'dark':
      inpageSkin = InpageSkinKeys.DARK;
      break;
    case 'light':
    default:
      inpageSkin = InpageSkinKeys.LIGHT;
  }
  return inpageSkin;
}

class InpageSkin extends Component {
  constructor(props, context) {
    super(props, context);
    var inpageSkin = getInpageSkin(props.value);
    this.state = {
      error: null,
      success: null,
      inpageSkin: inpageSkin
    };
  }

  handleChange(value) {
    var inpageSkin = getInpageSkin(value);
    this.setState({ inpageSkin });
    if (this.props.autoSave) {
      this.props.editSpot({ inpage_skin: value });
    }
  }

  getValue() {
    return this.state.inpageSkin.value;
  }

  openModal() {
    this.refs.modalInpageSkin.show();
  }

  closeModal() {
    this.refs.modalInpageSkin.hide();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ inpageSkin: getInpageSkin(nextProps.value) });
  }

  render() {
    return (
      <div className="inpage-skin-selection">
        <RadioButtonsInput
          name="inpage-skin"
          className="inpage-skin"
          title="Comments Color Scheme"
          description="Please select a color scheme that best fits your site’s design."
          value={this.state.inpageSkin.value}
          learnMore={this.openModal.bind(this)}
          onChange={this.handleChange.bind(this)}
          options={[InpageSkinKeys.LIGHT, InpageSkinKeys.DARK]}
        />
        <Modal ref="modalInpageSkin" className="modal-inpage-skin">
          <ModalInpageSkin onClose={this.closeModal.bind(this)} />
        </Modal>
      </div>
    );
  }
}

InpageSkin.propTypes = {
  value: PropTypes.oneOf(['light', 'dark']),
  autoSave: PropTypes.bool,
};

InpageSkin.displayName = 'InpageSkin';

export default InpageSkin;
